import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Download_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 29C5 28.4477 5.44772 28 6 28L26 28C26.5523 28 27 28.4477 27 29C27 29.5523 26.5523 30 26 30L6 30C5.44772 30 5 29.5523 5 29ZM6.25259 15.3356C6.61951 14.9229 7.25158 14.8857 7.66436 15.2526L15 21.7732L15 3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3L17 21.7732L24.3356 15.2526C24.7484 14.8857 25.3805 14.9229 25.7474 15.3356C26.1143 15.7484 26.0771 16.3805 25.6644 16.7474L16.6644 24.7474C16.2855 25.0842 15.7145 25.0842 15.3356 24.7474L6.33564 16.7474C5.92285 16.3805 5.88567 15.7484 6.25259 15.3356Z"
            />
        </SvgStyled>
    );
};

export default Download_lg;
